import * as api from '../../api/api';
import HttpMethods from '../../../enums/http-methods';

/**
 * Retrieves an xcaliber valid token from the user service.
 * This token can be used to make authenticated calls to the provider directory.
 * @returns {Promise<>}
 */
export const fetchXCaliberToken = async () => {
  try {
    return await api.requestJSON<CMxAPI.XCaliberTokenResponse>(
      `/directoryServices/apiToken/v1`,
      {
        method: HttpMethods.POST,
        body: undefined
      }
    );
  } catch (e) {
    console.error(e);
    throw e;
  }
};
